import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy — cart/orders live on /parts. */
export const Route = createFileRoute("/cart")({
  beforeLoad: () => {
    throw redirect({ to: "/parts" });
  },
  component: () => null,
});
